export const AUTH_COOKIE = 'authToken'

export enum GAMES {
    ZKRATKA,
    SIFT,
    HIDDEN
}

export const GAME_TYPE = GAMES.SIFT

export enum FILE_TYPE {
    PDF = '.pdf',
    XML = ',xml'
}

export enum ETextInputType {
    INPUT = 'input',
    TEXTAREA = 'textarea',
    PASSWORD = 'password',
}